import { useAuthStore } from '@/store/authStore'

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:8000'

export class ApiError extends Error {
  status: number
  detail?: string
  constructor(status: number, message: string, detail?: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.detail = detail
  }
}

/**
 * Base fetch wrapper. Attaches the JWT bearer header from the auth store and
 * triggers a client-side logout on 401 — mirroring the reference repo's
 * openapi-fetch middleware (bearerMiddleware + unauthorizedMiddleware).
 *
 * `/api/auth/me` is exempt from the 401 → logout redirect: hydrate() probes it
 * with a possibly-stale token and handles the failure internally, so we avoid a
 * recursive logout there.
 */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = useAuthStore.getState().token
  const headers = new Headers(init.headers)
  if (token) headers.set('Authorization', `Bearer ${token}`)
  if (init.body != null && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }

  const response = await fetch(`${baseUrl}${path}`, { ...init, headers })

  if (response.status === 401) {
    const isMeProbe = path.endsWith('/api/auth/me')
    if (!isMeProbe) {
      void useAuthStore.getState().logout({ skipServerCall: true })
    }
  }

  return response
}
